module.exports = __webpack_public_path__ + "img/industrias.2d7143d5.jpeg";